import { render, staticRenderFns } from "./CurrencyFilter.vue?vue&type=template&id=4509d7f4"
import script from "./CurrencyFilter.vue?vue&type=script&lang=js"
export * from "./CurrencyFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports